import React, { FC } from 'react'
import { theme, FontSizeProps, ColorProps } from '../../../theme'

export const CheckCircleOutline: FC<{
  color?: ColorProps
  size?: FontSizeProps
}> = ({ color, size }) => {
  return (
    <svg
      width={theme.fontSizes[size!]}
      height={theme.fontSizes[size!]}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00027 31.8047C7.8936 45.0047 18.6056 55.8927 31.8056 55.9994C45.0056 56.106 55.8936 45.394 56.0003 32.194C56.1069 18.9967 45.3949 8.10869 32.1949 7.99935C18.9949 7.89269 8.10693 18.6074 8.00027 31.8047ZM2.66693 31.762C2.80027 15.498 15.9736 2.53535 32.2376 2.66602C48.5043 2.79935 61.4643 15.9727 61.3336 32.2367C61.2003 48.5034 48.0296 61.4634 31.7629 61.3327C15.4963 61.202 2.53627 48.0287 2.66693 31.762ZM29.3456 34.6559L42.6896 21.3066C43.6949 20.3012 45.3296 20.3066 46.3269 21.3226L46.5643 21.5652C47.5563 22.5732 47.5403 24.1946 46.5323 25.1866L30.2256 41.1972C29.2256 42.1812 27.6229 42.1759 26.6283 41.1892L18.4896 33.0986C17.4789 32.0932 17.4816 30.4559 18.5003 29.4559L18.7563 29.2026C19.7776 28.2026 21.4176 28.2292 22.4043 29.2666L27.5136 34.6346C28.0096 35.1545 28.8363 35.1652 29.3456 34.6559Z"
        fill={theme.colors[color!]}
      />
    </svg>
  )
}

CheckCircleOutline.defaultProps = {
  color: 'black',
  size: 'x3',
}
